import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UtilsService } from './utils.service';
import { ErrorLog } from '../models/ErrorLog';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService
  ) {}

  searchErrorLogs(searchCriteria: any): Observable<Array<ErrorLog>> {
    const url = `${this.apiBaseUrl}/error-logs/search`;
    return this.http
      .post<Array<ErrorLog>>(url, searchCriteria)
      .pipe(catchError(this.utilsService.handleErr));
  }

  getErrorLogById(id: string): Observable<ErrorLog> {
    const url = `${this.apiBaseUrl}/error-log/${id}`;
    return this.http
      .get<ErrorLog>(url)
      .pipe(catchError(this.utilsService.handleErr));
  }

  /**
   * Report a client-side error to the backend for permanent storage.
   * Fire-and-forget: errors during reporting are silently caught.
   */
  reportError(errorData: {
    errorCode?: number;
    errorName?: string;
    errorMessage?: string;
    stackTrace?: string;
    httpStatus?: number;
    apiUrl?: string;
    httpMethod?: string;
    uiUrl?: string;
    additionalInfo?: any;
  }): void {
    const url = `${this.apiBaseUrl}/error-log`;
    this.http.post(url, errorData).subscribe({
      error: (err) => {
        // Silently catch - avoid infinite loops
        console.error('Failed to report error to backend:', err);
      }
    });
  }
}
